import { Box, Tabs, Tab } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingBottom: theme.spacing(2),
  '& .WTTitleContainer': {
    color: theme.palette.common.fogWhite,
    '& .WTSubTitle': {
      marginBottom: theme.spacing(1.5),
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(0.75),
      },
    },
    '& .MuiTypography-h7': {
      fontSize: 'inherit !important',
      [theme.breakpoints.down('md')]: {
        fontSize: 'inherit !important',
      },
    },
  },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  '&.NWTVertical': {
    flexDirection: 'column',
    alignItems: 'stretch',
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.down('lg')]: {
      paddingBottom: theme.spacing(2),
    },
    '& .WTTitleContainer': {
      marginBottom: theme.spacing(4),
      [theme.breakpoints.down('lg')]: {
        marginBottom: theme.spacing(3),
      },
    },
  },
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  minHeight: 'unset',
  border: `1px solid ${theme.palette.divider[7]}`,
  borderRadius: theme.spacing(0.75),
  padding: theme.spacing(0.5),
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiTabs-flexContainer': {
    gap: theme.spacing(0.5),
  },
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(3, 0),
  },
  '&.NWTVertical': {
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(0),
    },
  },
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  minHeight: 'unset',
  minWidth: 'unset',
  flex: 1,
  border: '1px solid transparent',
  fontSize: theme.typography.pxToRem(16),
  padding: theme.spacing(0.75, 2),
  borderRadius: theme.spacing(0.5),
  textTransform: 'none',
  transition: 'all 0.2s ease',
  outline: 'none',
  '&:hover:not(.Mui-selected)': {
    backgroundColor: theme.palette.overlay[1],
    border: `1px solid ${theme.palette.divider[3]}`,
  },
  '&.Mui-selected': {
    cursor: 'default',
    color: theme.palette.common.fogWhite,
    backgroundColor: theme.palette.background.tertiary,
  },
}));

export default StyledBox;
